<div class="header-bar">
  <h1>Supplier Schedule</h1>
</div>
<div class="content-container">
  <div *ngIf="jobInfo" class="ui-g filterPanel form-group">
    <div class="ui-g-12 ui-lg-3 ui-md-3">
      <div class="deploy-job-number">
        {{ jobInfo.jobNumber
        }}<span class="job-task-type" *ngIf="selectedJobTask">{{
          ' [' + selectedJobTask.taskTypeName + ']'
        }}</span>
        <div class="order-customer" *ngIf="selectedJobOrder">
          {{ selectedJobOrder.customer.name }}
        </div>
      </div>
    </div>

    <div class="ui-g-12 ui-lg-2 ui-md-2">
      <p-dropdown
        [options]="jobOrders"
        [(ngModel)]="selectedJobOrder"
        (onChange)="onSelectedJobOrderChanged($event.value)"
        placeholder="Select order"
        class="job-dropdown"
      >
      </p-dropdown>
    </div>
    <div class="ui-g-12 ui-lg-3 ui-md-3">
      <p-dropdown
        [options]="jobTasks"
        [(ngModel)]="selectedJobTask"
        (onChange)="onSelectedJobTaskChanged($event.value)"
        placeholder="Select task"
        class="job-dropdown"
      >
      </p-dropdown>
    </div>
    <div *ngIf="selectedJobTask" class="ui-g-12 ui-lg-3 ui-md-3">
      Location:
      <p-radioButton
        class="order-radio-button"
        name="orderByPickup"
        #orderByTask
        value="orderPickup"
        [(ngModel)]="orderRadioButtonVal"
        (ngModelChange)="handleOrderByChange($event)"
        label="{{ selectedJobTask.pickupLocation.city }}"
        inputId="1"
      ></p-radioButton>
      <p-radioButton
        class="order-radio-button"
        name="orderByDropoff"
        #orderByTask
        value="orderDropoff"
        [(ngModel)]="orderRadioButtonVal"
        (ngModelChange)="handleOrderByChange($event)"
        label="{{ selectedJobTask.dropoffLocation.city }}"
        inputId="2"
      ></p-radioButton>
      <div class="task-pickup-info">
        Pickup: <b>{{ getTaskPickupDate(selectedJobTask) }}</b>
      </div>
    </div>
  </div>

  <form (ngSubmit)="search()" style="width: 100%">
    <div class="control-panel form-group filterPanel">
      <div class="padtop-date">
        <table style="width: 100%; border-collapse: collapse">
          <tr>
            <td style="width: 1%"><strong>From:</strong></td>
            <td>
              <p-calendar
                [(ngModel)]="filterVal.filters.fromDate.value"
                name="createDateFrom"
                appendTo="body"
                [inputStyle]="{ width: '100%', 'overflow-x': 'hidden' }"
                [style]="{ width: '100%' }"
                dateFormat="dd/mm/yy"
                (ngModelChange)="onDateChange($event)"
              ></p-calendar>
            </td>
          </tr>
        </table>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="supplier"
          [options]="supplierList"
          [(ngModel)]="filterVal.filters.supplierList.value"
          maxSelectedLabels="1"
          styleClass="filterItem"
          defaultLabel="Suppliers"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(supplierList, selectedItems, 'Supplier(s)') }} &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="classification"
          [options]="classifications"
          maxSelectedLabels="1"
          [(ngModel)]="filterVal.filters.classifications.value"
          styleClass="filterItem"
          defaultLabel="Classification"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(classifications, selectedItems, 'Classification(s)') }}
              &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="engineiusArea"
          [options]="engineiusAreas"
          [(ngModel)]="filterVal.filters.engineiusAreaIds.value"
          styleClass="filterItem"
          defaultLabel="All Regions"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(engineiusAreas, selectedItems, 'Regions(s)') }} &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="engineiusRegion"
          [options]="engineiusRegions"
          [(ngModel)]="filterVal.filters.engineiusRegionIds.value"
          styleClass="filterItem"
          defaultLabel="All Areas"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(engineiusRegions, selectedItems, 'Areas(s)') }} &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="organisationContractType"
          [options]="contractTypes"
          maxSelectedLabels="1"
          [(ngModel)]="filterVal.filters.contractTypeIds.value"
          styleClass="filterItem"
          defaultLabel="Contract Type(s)"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(contractTypes, selectedItems, 'Contract Type(s)') }}
              &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="padtop">
        <p-multiSelect
          name="organisationSDGroup"
          [options]="organisationSDGroups"
          maxSelectedLabels="1"
          [(ngModel)]="filterVal.filters.serviceDeliveryGroupIds.value"
          styleClass="filterItem"
          defaultLabel="Service Group(s)"
        >
          <ng-template let-selectedItems pTemplate="selectedItems">
            <div class="selected-items">
              {{ showSelectLabels(organisationSDGroups, selectedItems, 'Service Group(s)') }}
              &nbsp;
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="">
        <table style="width: 100%; border-collapse: collapse">
          <tr>
            <td>
              <p-multiSelect
                name="organisationTags"
                [options]="organisationTags"
                maxSelectedLabels="1"
                [(ngModel)]="filterVal.filters.organisationTagIds.value"
                styleClass="filterItem"
                defaultLabel="Tag(s)"
              >
                <ng-template let-selectedItems pTemplate="selectedItems">
                  <div class="selected-items">
                    {{ showSelectLabels(organisationTags, selectedItems, 'Tag(s)') }} &nbsp;
                  </div>
                </ng-template>
              </p-multiSelect>
            </td>
            <td style="width: 1%">
              <button
                pButton
                type="submit"
                icon="ui-icon-search"
                style="border-radius: 5%"
              ></button>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!--
    <div class="flex">

      <div class="pl-2 p-1 order-day-panel" style="flex-grow: 1;"
           pTooltip="Sort suppliers by availability, then number of jobs completed in last 30 days"
           tooltipPosition="bottom">
        <div class="sortby-desc">Sort by 'operating factors' on</div>
        <p-radioButton class="order-radio-button" name="dayOrder" #dayOrder value="day1" [(ngModel)]="radioButtonVal"
                       (ngModelChange)="handleDay1OrderChange($event)"
                       label="" inputId="1"></p-radioButton>
      </div>
      <div class="p-1 order-day-panel" style="flex-grow: 1;"
           pTooltip="Sort suppliers by availability, then number of jobs completed in last 30 days"
           tooltipPosition="bottom">
        <div class="sortby-desc">Sort by 'operating factors' on</div>
        <p-radioButton class="order-radio-button" name="dayOrder" #dayOrder value="day2" [(ngModel)]="radioButtonVal"
                       (ngModelChange)="handleDay2OrderChange($event)"
                       label="" inputId="2"></p-radioButton>
      </div>
      <div class="p-1 order-day-panel" style="flex-grow: 1;"
           pTooltip="Sort suppliers by availability, then number of jobs completed in last 30 days"
           tooltipPosition="bottom">
        <div class="sortby-desc">Sort by 'operating factors' on</div>
        <p-radioButton class="order-radio-button" name="dayOrder" #dayOrder value="day3" [(ngModel)]="radioButtonVal"
                       (ngModelChange)="handleDay3OrderChange($event)"
                       label="" inputId="3"></p-radioButton>
      </div>
    </div>
    -->

    <div class="control-panel-sub">
      <div style="flex-grow: 1">
        <div style="display: flex; flex-wrap: wrap">
          <span class="p-1 order-day-panel bold-text" style="display: inline-block; width: 130px"
            >Job View Status:</span
          >

          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="jvsAll"
              #jobViewStatus
              value="0"
              pTooltip="Do not filter list on job view status"
              [(ngModel)]="jvsRadioButtonVal"
              (ngModelChange)="handleJobViewStatusChange($event)"
              label="All"
              inputId="1"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="jvsWatched"
              #jobViewStatus
              value="1"
              pTooltip="Show suppliers who have watched this job"
              [(ngModel)]="jvsRadioButtonVal"
              (ngModelChange)="handleJobViewStatusChange($event)"
              label="Watched"
              inputId="2"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="jvsRejected"
              #jobViewStatus
              value="2"
              pTooltip="Show suppliers who have hidden this job"
              [(ngModel)]="jvsRadioButtonVal"
              (ngModelChange)="handleJobViewStatusChange($event)"
              label="Hidden"
              inputId="3"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="jvsNotRejected"
              #jobViewStatus
              value="3"
              pTooltip="Show suppliers who have not hidden this job"
              [(ngModel)]="jvsRadioButtonVal"
              (ngModelChange)="handleJobViewStatusChange($event)"
              label="Not Hidden"
              inputId="4"
            ></p-radioButton>
          </div>
        </div>
      </div>

      <div style="flex-grow: 1">
        <div style="display: flex; flex-wrap: wrap">
          <span class="p-1 order-day-panel bold-text" style="display: inline-block; width: 130px"
            >Working Hours:
          </span>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="workFilter"
              #workFilter
              value="work0"
              [(ngModel)]="filterButtonVal"
              (ngModelChange)="handleWorkFilterChange($event, 0)"
              label="Show all"
              inputId="4"
              pTooltip="Show all suppliers regardless of their work schedule"
              tooltipPosition="top"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="workFilter"
              #workFilter
              value="work1"
              [(ngModel)]="filterButtonVal"
              (ngModelChange)="handleWorkFilterChange($event, 1)"
              label="Up to 2 hours"
              inputId="5"
              pTooltip="Show suppliers who have less than 2 hours of total work in their schedule"
              tooltipPosition="top"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="workFilter"
              #workFilter
              value="work2"
              [(ngModel)]="filterButtonVal"
              (ngModelChange)="handleWorkFilterChange($event, 2)"
              label="Up to 4 hours"
              inputId="6"
              pTooltip="Show suppliers who have less than 4 hours of total work in their schedule"
              tooltipPosition="top"
            ></p-radioButton>
          </div>
          <div class="p-1 order-day-panel">
            <p-radioButton
              class="order-radio-button"
              name="workFilter"
              #workFilter
              value="work3"
              [(ngModel)]="filterButtonVal"
              (ngModelChange)="handleWorkFilterChange($event, 3)"
              label="No work"
              inputId="7"
              pTooltip="Show only suppliers with no work in their schedule"
              tooltipPosition="top"
            ></p-radioButton>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="isLoading" style="text-align: center; font-size: 1.25rem; z-index: 99; padding: 10px">
    <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading Schedules, please wait...
  </div>

  <div id="datatable-overrider" *ngIf="!isLoading">
    <p-table
      #dt
      [responsive]="true"
      [value]="slice"
      [paginator]="true"
      [lazy]="true"
      [totalRecords]="page.total"
      [rows]="perPage"
      [paginatorPosition]="'both'"
      (onLazyLoad)="loadLazy($event)"
      [rowsPerPageOptions]="[100, 50, 25]"
      [pageLinks]="5"
      rowHover="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="ui-column-title column0">Supplier</th>
          <th
            *ngFor="let column of viewDates; let i = index"
            #colDay
            class="ui-column-title data-column-date column{{ i + 1 }} {{
              radioButtonVal == 'day' + (i + 1) ? 'highlight' : ''
            }}"
          >
            <div (click)="handleDayOrderChange(i)" style="cursor: pointer">
              <span class="header-date">{{ column | datex : "ddd Do MMM 'YY" }}</span>
              <i
                class="fa fa-sort-amount-asc ml-4"
                pTooltip="Sort suppliers by availability, then number of jobs completed in last 30 days"
              ></i>
              <div *ngIf="availCounts && availCounts.length > 0">
                <span
                  class="availability-count avail-count"
                  pTooltip="There are {{
                    availCounts[i].avail
                  }} suppliers explicitly available on {{ column | datex : 'ddd Do MMM \'YY' }}"
                >
                  <i class="fa fa-user"></i> {{ availCounts[i].avail }}</span
                >
                <span
                  class="availability-count notsure-count"
                  pTooltip="There are {{
                    availCounts[i].notsure
                  }} suppliers who have not specified availability on {{
                    column | datex : 'ddd Do MMM \'YY'
                  }}"
                >
                  <i class="fa fa-user"></i> {{ availCounts[i].notsure }}</span
                >
                <span
                  class="availability-count unavail-count"
                  pTooltip="There are {{ availCounts[i].unavail }} suppliers unavailable on {{
                    column | datex : 'ddd Do MMM \'YY'
                  }}"
                >
                  <i class="fa fa-user"></i> {{ availCounts[i].unavail }}</span
                >
                <span
                  class="availability-count unavail-count"
                  pTooltip="There are {{
                    availCounts[i].doNotDisturb
                  }} suppliers set as Do Not Disturb on {{ column | datex : 'ddd Do MMM \'YY' }}"
                >
                  <i class="fa fa-minus-circle"></i> {{ availCounts[i].doNotDisturb }}</span
                >
                <span
                  class="availability-count"
                  pTooltip="Estimated availability on {{ column | datex : 'ddd Do MMM \'YY' }}"
                >
                  {{ availCounts[i].availPerc.toFixed(2) }}%</span
                >
              </div>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-index="rowIndex">
        <tr [pSelectableRow]="row">
          <td class="data-column-date column0">
            <div class="row-number">{{ '#' + (index + 1) }}</div>

            <div class="supplier-card-wrapper">
              <div class="supplier-card">
                <div class="supplier-area">
                  <div class="supplier-region">
                    <div>{{ row.area + ' ' + getAreaPostRegion(row.postcode) }}</div>
                    <div class="contract-type">
                      {{ row.organisationContractType.name }}
                      <span *ngIf="row.serviceDeliveryGroup" class="sd-group"
                        >({{ row.serviceDeliveryGroup.name }})</span
                      >
                    </div>
                    <div *ngIf="selectedJobTask">{{ row.distanceFromTask + 'm' }}</div>
                  </div>
                  <div class="supplier-calendar">
                    <img
                      src="{{ availabilityImageUrl }}"
                      class="supplier-availability"
                      alt="availability"
                      (click)="editAvailability(row)"
                    />
                  </div>
                </div>

                <div *ngIf="row.supplierOperationalData">
                  <div
                    class="supplier-classification"
                    [ngClass]="{
                      'supplier-classification-new':
                        row.supplierOperationalData.classification === 'New',
                      'supplier-classification-plated':
                        row.supplierOperationalData.classification === 'Plated'
                    }"
                  ></div>

                  <div class="flex flex-wrap">
                    <div class="flex-grow-1 text-left info-spacer supplier-name">
                      {{ row.supplierName }}
                    </div>
                  </div>

                  <div class="flex flex-wrap">
                    <div *ngIf="jobId" style="margin-bottom: 8px">
                      <div class="flex-shrink-1">
                        <span
                          *ngIf="row.jobWatched"
                          pTooltip="Supplier is watching this job"
                          class="job-view watched"
                          >Watched</span
                        >
                        <span
                          *ngIf="row.jobRejected"
                          class="job-view rejected"
                          pTooltip="Supplier hidden this job"
                          >Hidden</span
                        >
                        <span *ngIf="!row.jobRejected" pTooltip="Hide this job">
                          <button
                            pButton
                            class="ui-button-danger"
                            icon="ui-icon-trash"
                            label="Hide"
                            style="border-radius: 5%; margin-left: 0px !important"
                            (click)="rejectJob(row)"
                          ></button>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style="display: flex; flex-wrap: wrap">
                    <span *ngFor="let tag of row.tagEntities" [pTooltip]="tag.description">
                      <span class="tag"><i class="fa fa-tag"></i> {{ tag.name }}</span
                      >&nbsp;
                    </span>
                  </div>

                  <div>
                    <b>{{ row.supplierOperationalData.classification }}</b>
                  </div>
                  <div class="info-spacer supplier-telephone">
                    <a href="tel:{{ row.telephone }}">
                      <i class="fa fa-phone-square"></i>&nbsp;
                      {{ row.telephone }}
                    </a>
                  </div>
                  <div class="supplier-jobs-datablock">
                    <div class="info-spacer">
                      <span class="supplier-jobs-datablock-value">{{
                        row.supplierOperationalData.jobsInLast30Days
                      }}</span>
                      jobs in last 30 days
                    </div>
                    <div class="info-spacer">
                      <span class="supplier-jobs-datablock-value"
                        >{{ row.supplierOperationalData.completionRateLast30Days }} %</span
                      >
                      completed
                    </div>

                    <div class="flex flex-wrap">
                      <div class="flex-grow-1 text-left">
                        Last job: {{ (row.lastTask | date : 'dd/MM/yy') || 'N/A' }}
                      </div>
                      <div class="flex-grow-1 text-right">
                        Joined: {{ row.dateCreated | date : 'dd/MM/yy' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin-top: 8px; margin-bottom: 4px">
                <i class="fa fa-phone-square"></i>&nbsp;
                <span *ngIf="row.recentCalls && row.recentCalls.length > 0">Recent Calls</span>
                <span *ngIf="!row.recentCalls || row.recentCalls.length == 0">No Recent Calls</span>
              </div>
              <div class="call-table-wrapper" *ngIf="row.recentCalls && row.recentCalls.length > 0">
                <table class="call-table" *ngIf="row.recentCalls">
                  <thead>
                    <tr>
                      <th>Operator</th>
                      <th>Direction</th>
                      <th>Date</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let call of row.recentCalls" class="no-wrap-cells">
                      <td>{{ call.operatorName }}</td>
                      <td>{{ call.outboundCall ? 'Outbound' : 'Inbound' }}</td>
                      <td>{{ call.created | date : 'EEE dd MMM HH:mm' }}</td>
                      <td>{{ call.wrapUpReason }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </td>

          <td
            *ngFor="let column of viewDates; let i = index"
            #colDay
            class="data-column-date column{{ i + 1 }} {{
              radioButtonVal == 'day' + (i + 1) ? 'highlight' : ''
            }}"
          >
            <div
              *ngIf="row.availabilityState[i] == SupplierAvailabilityStateEnum.available"
              class="availability-container"
            >
              <i
                class="fa fa-check availability-image is-available"
                pTooltip="Supplier is available for work on {{ column | datex : 'ddd Do MMM' }}"
              ></i>
            </div>

            <div
              *ngIf="row.availabilityState[i] == SupplierAvailabilityStateEnum.unavailable"
              class="availability-container"
            >
              <i
                class="fa fa-times-circle availability-image not-available"
                pTooltip="Supplier is not available for work on {{ column | datex : 'ddd Do MMM' }}"
              ></i>
            </div>

            <div
              *ngIf="row.availabilityState[i] == SupplierAvailabilityStateEnum.unset"
              class="availability-container"
            >
              <i
                class="fa fa-exclamation-triangle availability-image not-set"
                pTooltip="Supplier has not specified their availability for {{
                  column | datex : 'ddd Do MMM'
                }}"
              ></i>
            </div>

            <div
              *ngIf="row.availabilityState[i] == SupplierAvailabilityStateEnum.doNotDisturb"
              class="availability-container"
            >
              <i
                class="fa fa-minus-circle availability-image not-available"
                pTooltip="Supplier is set as Do Not Disturb on {{ column | datex : 'ddd Do MMM' }}"
              ></i>
            </div>

            <div *ngFor="let taskGroup of row.groupedTasks[i] | keyvalue">
              <div
                [ngClass]="{
                  'task-block-done': taskGroup.value.taskSummary.statusText == 'Closed',
                  'task-block-started': taskGroup.value.taskSummary.statusText == 'Started',
                  'task-block-created': taskGroup.value.taskSummary.statusText == 'Created',
                  'task-block-cancelled': taskGroup.value.taskSummary.statusText == 'Cancelled'
                }"
                class="task-block"
              >
                <div class="task-date-time" style="display: flex">
                  <span
                    pTooltip="Earliest pickup datetime"
                    tooltipPosition="top"
                    *ngIf="isPickupAnotherDay(taskGroup.value.taskSummary)"
                    >{{
                      taskGroup.value.taskSummary.pickupEarliestDateTime | datex : 'Do MMM HH:mm'
                    }}
                  </span>
                  <span
                    pTooltip="Earliest pickup time"
                    tooltipPosition="top"
                    *ngIf="!isPickupAnotherDay(taskGroup.value.taskSummary)"
                    >{{ taskGroup.value.taskSummary.pickupEarliestDateTime | datex : 'HH:mm' }}
                  </span>
                  &nbsp;-&nbsp;
                  <span
                    pTooltip="Latest drop-off datetime"
                    tooltipPosition="top"
                    *ngIf="isDropoffAnotherDay(taskGroup.value.taskSummary)"
                    >{{
                      taskGroup.value.taskSummary.dropoffLatestDateTime | datex : 'Do MMM HH:mm'
                    }}
                  </span>
                  <span
                    pTooltip="Latest drop-off time"
                    tooltipPosition="top"
                    *ngIf="!isDropoffAnotherDay(taskGroup.value.taskSummary)"
                    >{{ taskGroup.value.taskSummary.dropoffLatestDateTime | datex : 'HH:mm' }}</span
                  >

                  <span class="task-status" pTooltip="Job status" tooltipPosition="right">
                    <span
                      class="incident-icon"
                      *ngIf="taskGroup.value.taskSummary.priorityDeployment"
                    >
                      <i
                        pTooltip="Priority Deployment Job"
                        class="fa fa-lg fa-exclamation-circle"
                        style="color: #c00"
                      ></i>
                    </span>
                    {{ taskGroup.value.taskSummary.statusText }}
                  </span>
                </div>

                <div style="display: flex; flex-wrap: wrap; margin-bottom: 5px">
                  <div style="flex-grow: 1" class="-locations">
                    <span pTooltip="Pickup postcode" tooltipPosition="bottom">{{
                      taskGroup.value.taskSummary.pickupLocation.postcode | postcode
                    }}</span>
                    &nbsp;<i class="fa fa-caret-right"></i>&nbsp;
                    <span pTooltip="Drop-off postcode" tooltipPosition="bottom">{{
                      taskGroup.value.taskSummary.dropoffLocation.postcode | postcode
                    }}</span>
                  </div>
                  <div style="flex-shrink: 1" pTooltip="Task distance">
                    {{ Math.round(taskGroup.value.taskSummary.distanceInMiles) + ' miles' }}
                  </div>
                </div>

                <div *ngFor="let task of taskGroup.value.tasks">
                  <div class="job-line">
                    <a href="/app/jobscreen/{{ task.jobId }}" target="_blank">
                      <div style="display: flex; flex-wrap: wrap">
                        <div style="flex-grow: 1" class="task-status">
                          <span
                            class="task-job-number"
                            pTooltip="Job number"
                            tooltipPosition="bottom"
                            >{{ task.jobNumber }}</span
                          >
                          <span
                            class="vrm"
                            pTooltip="Vehicle registration"
                            tooltipPosition="bottom"
                            >{{ task.vehicle.registrationNumber }}</span
                          >
                        </div>
                        <div style="flex-grow: 1; color: rgb(51, 51, 51)">
                          <span pTooltip="Task type">{{ task.taskTypeName }}</span>
                        </div>
                        <div
                          style="flex-shrink: 1; color: rgb(51, 51, 51)"
                          pTooltip="Estimated time"
                        >
                          <i class="fa fa-clock-o"></i>&nbsp;{{
                            stringToDuration(task.estimateTime)
                          }}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!--
  <p-dataTabl #dt
               [responsive]="true"
               [value]="slice"
               [paginator]="true"
               [lazy]="true"
               [totalRecords]="page.total"
               [rows]="perPage"
               [paginatorPosition]="'both'"
               (onLazyLoad)="loadLazy($event)"
               [rowsPerPageOptions]="[100,50,25]" [pageLinks]="5" rowHover="true">
    <p-column field="Name" [editable]="false" styleClass="column0">
      <ng-template pTemplate="header">
        <span style="font-size: 17px;">Supplier</span>
      </ng-template>
      <ng-template let-col let-row="rowData" let-index="rowIndex" pTemplate="body">

        <div class="row-number">{{"#" + (index + 1) }}</div>

        <div class="supplier-card-wrapper">

          <div class="supplier-card">

            <div class="supplier-area">
              <div class="supplier-region">
                <div>{{row.area + " " + getAreaPostRegion(row.postcode)}}</div>
                <div class="contract-type">{{row.organisationContractType.name}} <span
                        *ngIf="row.serviceDeliveryGroup" class="sd-group">({{row.serviceDeliveryGroup.name}})</span>
                </div>
                <div *ngIf="selectedJobTask">{{ row.distanceFromTask + "m" }}</div>
              </div>
              <div class="supplier-calendar">
                <img src="{{availabilityImageUrl}}" class="supplier-availability" alt="availability"
                     (click)="editAvailability(row)"/>
              </div>
            </div>

            <div *ngIf="row.supplierOperationalData">
              <div class="supplier-classification" [ngClass]="{'supplier-classification-new':row.supplierOperationalData.classification === 'New',
                       'supplier-classification-plated':row.supplierOperationalData.classification === 'Plated'}">
              </div>

              <div class="flex flex-wrap">
                <div class="flex-grow-1 text-left info-spacer supplier-name">
                  {{row.supplierName}}
                </div>
              </div>

              <div class="flex flex-wrap">
                <div *ngIf="jobId" style="margin-bottom: 8px;">
                  <div class="flex-shrink-1">
                    <span *ngIf="row.jobWatched" pTooltip="Supplier is watching this job" class="job-view watched">Watched</span>
                    <span *ngIf="row.jobRejected" class="job-view rejected" pTooltip="Supplier rejected this job">Rejected</span>
                    <span *ngIf="!row.jobRejected" pTooltip="Reject this job">
                      <button pButton class="ui-button-danger" icon="ui-icon-trash" label="Reject"
                              style="border-radius:5%; margin-left: 0px !important;"
                              (click)="rejectJob(row)"></button>
                    </span>
                  </div>
                </div>
              </div>

              <div style="display: flex; flex-wrap: wrap">
                <span *ngFor="let tag of row.tagEntities" [pTooltip]="tag.description">
                  <span class="tag"><i class="fa fa-tag"></i> {{tag.name}}</span>&nbsp;
                </span>
              </div>

              <div><b>{{row.supplierOperationalData.classification}}</b></div>
              <div class="info-spacer supplier-telephone">
                <a href="tel:{{row.telephone}}">
                  <i class="fa fa-phone-square"></i>&nbsp;
                  {{row.telephone}}
                </a>
              </div>
              <div class="supplier-jobs-datablock">
                <div class="info-spacer">
                  <span class="supplier-jobs-datablock-value">{{row.supplierOperationalData.jobsInLast30Days}}</span>
                  jobs in last 30 days

                </div>
                <div class="info-spacer"><span
                        class="supplier-jobs-datablock-value">{{row.supplierOperationalData.completionRateLast30Days}}
                  %</span> completed
                </div>

                <div class="flex flex-wrap">
                  <div class="flex-grow-1 text-left">
                    Last job: {{ (row.lastTask | date: "dd/MM/yy") || 'N/A' }}
                  </div>
                  <div class="flex-grow-1 text-right">
                    Joined: {{ row.dateCreated | date: "dd/MM/yy" }}
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 8px; margin-bottom: 4px;"><i class="fa fa-phone-square"></i>&nbsp;
            <span *ngIf="row.recentCalls && row.recentCalls.length > 0">Recent Calls</span>
            <span *ngIf="!row.recentCalls || row.recentCalls.length == 0">No Recent Calls</span>
          </div>
          <div class="call-table-wrapper" *ngIf="row.recentCalls && row.recentCalls.length > 0">
            <table class="call-table" *ngIf="row.recentCalls">
              <thead>
              <tr>
                <th>Operator</th>
                <th>Direction</th>
                <th>Date</th>
                <th>Reason</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let call of row.recentCalls">
                <td>{{ call.operatorName }}</td>
                <td>{{ call.outboundCall ? 'Outbound' : 'Inbound' }}</td>
                <td>{{ call.created | date: 'EEE dd MMM HH:mm' }}</td>
                <td>{{ call.wrapUpReason }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </ng-template>
    </p-column>

    <p-column *ngFor="let column of viewDates; let i = index" #colDay field=""
              [editable]="false" class="data-column-date"
              styleClass="column{{i + 1}} {{radioButtonVal == ('day' + (i + 1)) ? 'highlight' : ''}}">

      <ng-template pTemplate="header">
        <div (click)="handleDayOrderChange(i)" style="cursor: pointer">
          <span class="header-date">{{ column | datex:'ddd Do MMM \'YY' }}</span>
          <i class="fa fa-sort-amount-asc ml-4"
             pTooltip="Sort suppliers by availability, then number of jobs completed in last 30 days"></i>
          <div *ngIf="availCounts && availCounts.length > 0">
            <span class="availability-count avail-count"
                  pTooltip="There are {{availCounts[i].avail}} suppliers explicitly available on {{ column | datex:'ddd Do MMM \'YY' }}">
              <i class="fa fa-user"></i> {{availCounts[i].avail}}</span>
            <span class="availability-count notsure-count"
                  pTooltip="There are {{availCounts[i].notsure}} suppliers who have not specified availability on {{ column | datex:'ddd Do MMM \'YY' }}">
              <i class="fa fa-user"></i> {{availCounts[i].notsure}}</span>
            <span class="availability-count unavail-count"
                  pTooltip="There are {{availCounts[i].unavail}} suppliers unavailable on {{ column | datex:'ddd Do MMM \'YY' }}">
              <i class="fa fa-user"></i> {{availCounts[i].unavail}}</span>
            <span class="availability-count"
                  pTooltip="Estimated availability on {{ column | datex:'ddd Do MMM \'YY' }}">
              {{availCounts[i].availPerc.toFixed(2)}}%</span>
          </div>
        </div>

      </ng-template>

      <ng-template let-col let-data="rowData" let-index="rowIndex" pTemplate="body">

        <div *ngIf="data.isAvailable[i]" class="availability-container">
          <i class="fa fa-check availability-image is-available"
             pTooltip="Supplier is available for work on {{ column | datex:'ddd Do MMM' }}"></i>
        </div>

        <div *ngIf="data.isAvailable[i] == false" class="availability-container">
          <i class="fa fa-times-circle availability-image not-available"
             pTooltip="Supplier is not available for work on {{ column | datex:'ddd Do MMM' }}"></i>
        </div>

        <div *ngIf="data.isAvailable[i] == null" class="availability-container">
          <i class="fa fa-exclamation-triangle availability-image not-set"
             pTooltip="Supplier has not specified their availability for {{ column | datex:'ddd Do MMM' }}"></i>
        </div>

        <div *ngFor="let taskGroup of data.groupedTasks[i] | keyvalue">


          <div [ngClass]="{'task-block-done': taskGroup.value.taskSummary.statusText == 'Closed'
                      , 'task-block-started': taskGroup.value.taskSummary.statusText == 'Started'
                      , 'task-block-created': taskGroup.value.taskSummary.statusText == 'Created'
                      , 'task-block-cancelled': taskGroup.value.taskSummary.statusText == 'Cancelled'
                      }" class="task-block">

            <div class="task-date-time" style="display: flex">
              <span pTooltip="Earliest pickup datetime" tooltipPosition="top"
                    *ngIf="isPickupAnotherDay(taskGroup.value.taskSummary)">{{ taskGroup.value.taskSummary.pickupEarliestDateTime | datex: "Do MMM HH:mm" }}
              </span>
              <span pTooltip="Earliest pickup time" tooltipPosition="top"
                    *ngIf="!isPickupAnotherDay(taskGroup.value.taskSummary)">{{ taskGroup.value.taskSummary.pickupEarliestDateTime | datex: "HH:mm" }}
              </span>
              &nbsp;-&nbsp;
              <span pTooltip="Latest drop-off datetime" tooltipPosition="top"
                    *ngIf="isDropoffAnotherDay(taskGroup.value.taskSummary)">{{ taskGroup.value.taskSummary.dropoffLatestDateTime | datex: "Do MMM HH:mm" }}
              </span>
              <span pTooltip="Latest drop-off time" tooltipPosition="top"
                    *ngIf="!isDropoffAnotherDay(taskGroup.value.taskSummary)">{{ taskGroup.value.taskSummary.dropoffLatestDateTime | datex: "HH:mm" }}</span>

              <span class="task-status" pTooltip="Job status" tooltipPosition="right">
                <span class="incident-icon" *ngIf="taskGroup.value.taskSummary.priorityDeployment">
                  <i pTooltip="Priority Deployment Job" class="fa fa-lg fa-exclamation-circle" style="color: #c00;"></i>
                </span>
                {{taskGroup.value.taskSummary.statusText}}
              </span>
            </div>


            <div style="display: flex; flex-wrap: wrap; margin-bottom: 5px;">
              <div style="flex-grow: 1;" class="-locations">
                <span pTooltip="Pickup postcode"
                      tooltipPosition="bottom">{{ taskGroup.value.taskSummary.pickupLocation.postcode | postcode }}</span>
                &nbsp;<i class="fa fa-caret-right"></i>&nbsp;
                <span pTooltip="Drop-off postcode"
                      tooltipPosition="bottom">{{ taskGroup.value.taskSummary.dropoffLocation.postcode | postcode }}</span>
              </div>
              <div style="flex-shrink: 1;"
                   pTooltip="Task distance">{{ Math.round(taskGroup.value.taskSummary.distanceInMiles) + " miles" }}</div>
            </div>

            <div *ngFor="let task of taskGroup.value.tasks">

              <div class="job-line">

                <a href="/app/jobscreen/{{task.jobId}}" target="_blank">
                  <div style="display: flex; flex-wrap: wrap;">
                    <div style="flex-grow: 1" class="task-status">
                      <span class="task-job-number" pTooltip="Job number"
                            tooltipPosition="bottom">{{task.jobNumber}}</span>
                      <span class="vrm" pTooltip="Vehicle registration"
                            tooltipPosition="bottom">{{task.vehicle.registrationNumber}}</span>
                    </div>
                    <div style="flex-grow: 1; color: rgb(51, 51, 51);">
                      <span pTooltip="Task type">{{task.taskTypeName}}</span>
                    </div>
                    <div style="flex-shrink: 1; color: rgb(51, 51, 51)" pTooltip="Estimated time">
                      <i class="fa fa-clock-o"></i>&nbsp;{{ stringToDuration(task.estimateTime) }}
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>

      </ng-template>
    </p-column>
  </p-dataTable>

-->
  </div>

  <!-- dialog for displaying/editing supplier availability -->
  <p-dialog
    #availabilityDialog
    header="Supplier Availability"
    [(visible)]="showSupplierAvailabilityDialog"
    [modal]="true"
    [responsive]="true"
    [style]="{ width: '750px' }"
    [resizable]="false"
    (visibleChange)="onSupplierAvailabilityClosed()"
  >
    <div class="ui-g ui-grid-responsive">
      <div class="ui-grid-col-12">
        <supplier-availability
          #supplierAvailability
          [supplierInfo]="supplierAvailabilityInfo"
        ></supplier-availability>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    header="Rejecting Job"
    [(visible)]="rejectJobDialogVisible"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '400px' }"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      Enter the reason for hiding this
      {{ jobInfo ? (jobInfo.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2') : '' }} job
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>

    <div class="ui-grid-row">
      <div style="clear: both"></div>

      <div *ngFor="let reason of rejectReasons" class="reject-reason">
        <p-radioButton
          [name]="reason.reason"
          [id]="reason.id"
          [label]="reason.reason"
          [value]="reason"
          [(ngModel)]="rejectReason"
        ></p-radioButton>
      </div>
      <div *ngIf="rejectReason?.requireText">
        <textarea
          pInputTextarea
          [(ngModel)]="rejectText"
          style="width: 100%; height: 150px"
          placeholder="Please specify other reason*"
        ></textarea>
      </div>
    </div>

    <div
      style="
        display: flex;
        margin-top: 20px;
        width: 100%;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
      "
    >
      <button
        type="button"
        [disabled]="rejectReason == null || (rejectReason?.requireText && !rejectText)"
        class="ui-button-danger"
        pButton
        icon="fa ui-icon-trash"
        (click)="confirmedRejectJob()"
        label="Hide Job"
        style="width: 100%"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="rejectJobDialogVisible = false"
        style="width: 100%"
      ></button>
    </div>
  </p-dialog>
</div>
